var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.cardData ? _c('div', {
    ref: "cardItemDv",
    staticClass: "img-item-dv"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.cardData.cover_img,
      expression: "cardData.cover_img"
    }],
    staticClass: "img-style",
    attrs: {
      "src": _vm.cardData.cover_img
    }
  }), _vm.cardData.headline || _vm.cardData.raw_title ? _c('div', {
    staticClass: "img-rec-dv",
    class: `bg-theme${_vm.themeClass}`
  }, [_vm.cardData.headline ? _c('div', {
    staticClass: "img-rec-dv-title"
  }, [_vm._v(_vm._s(_vm.cardData.headline))]) : _vm._e(), _vm.cardData.raw_title ? _c('div', {
    staticClass: "img-rec-dv-text"
  }, [_vm._v(_vm._s(_vm.cardData.raw_title))]) : _vm._e()]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };